import React from 'react';
import styles from './SideDrawer.module.css';

export type GrossActivityLevel = 'Low' | 'Normal' | 'Elevated';

type GrossActivityBadgeProps = {
  level: GrossActivityLevel;
  insufficientHistory?: boolean;
};

const GrossActivityBadge = ({ level, insufficientHistory }: GrossActivityBadgeProps) => {
  const levelClass =
    level === 'Elevated'
      ? styles.grossBadgeElevated
      : level === 'Low'
        ? styles.grossBadgeLow
        : styles.grossBadgeNormal;

  return (
    <span className={`${styles.grossBadge} ${levelClass}`} aria-label={`Gross Activity ${level}`} tabIndex={0}>
      Gross Activity: {level}
      <span className={styles.grossTooltip}>
        <span className={styles.grossTooltipLine}>
          Gross positioning reflects two-way leverage and potential volatility, not direction.
        </span>
        <span className={styles.grossTooltipLine}>
          Computed from gross % of open interest (long+short+spreading) vs history.
        </span>
        {insufficientHistory && (
          <span className={styles.grossTooltipNote}>Insufficient history</span>
        )}
      </span>
    </span>
  );
};

export default GrossActivityBadge;
